import type { OverlayPanelLabel } from "@frontend/pages/case-workspace/pathology/components/overlay-panel"

/** Tooltip for a legend / class entry, listing collapsed raw ids (aliases) when any. */
export function labelTitle(label: OverlayPanelLabel): string {
  const name = label.name ?? `label ${label.value}`
  return label.aliases && label.aliases.length > 0 ? `${name} (also ids ${label.aliases.join(", ")})` : name
}

/** True when the entry groups several raw label ids. */
export function hasLabelAliases(label: OverlayPanelLabel): boolean {
  return Boolean(label.aliases && label.aliases.length > 0)
}
